import {safeLocalStorage} from './safeStorage';
const ordered=value=>Array.isArray(value)?value.map(ordered):value&&typeof value==='object'?Object.fromEntries(Object.keys(value).sort().map(key=>[key,ordered(value[key])])):value;
export const demandDraftKey=(owner,role,target,project,criteria)=>owner?`mekandapro:demand:${JSON.stringify([owner,role,target,project,ordered(criteria)])}`:null;
export function readDemandDraft(key) {
  if(!key)return null;
  try {
    const row=JSON.parse(safeLocalStorage.getItem(key));
    // A8: taslak yalnız yapılandırılmış alanlar taşır; eski serbest metinli taslaklar (title/summary) gönderilemeyeceği için atılır.
    if(!row||!Number.isFinite(row.savedAt)||Date.now()-row.savedAt>7*86400000||!row.requestId||!row.form||['event_type','expected_attendees','event_date','event_time'].some(k=>typeof row.form[k]!=='string')||typeof row.form.date_flexible!=='boolean'||!Array.isArray(row.form.model_codes)){safeLocalStorage.removeItem(key);return null;}
    return row;
  } catch {return null;}
}
export const saveDemandDraft=(key,form,requestId)=>key?safeLocalStorage.setItem(key,JSON.stringify({form,requestId,savedAt:Date.now()})):false;
export const removeDemandDraft=key=>{if(key)safeLocalStorage.removeItem(key);};
